import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudienceForCount as GetAudienceForCountQuery,
    GetAudienceForCountVariables as GetAudienceForCountVariables,
    GetAudienceForCount_audience as Audience,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_FOR_COUNT from '../queries/get-audience-for-count.graphql';

export const useGetAudienceForCount = (
    id: string
): {
    audience: Audience | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
} => {
    const {loading, data, error, refetch, startPolling, stopPolling} = useQuery<
        GetAudienceForCountQuery,
        GetAudienceForCountVariables
    >(GET_AUDIENCE_FOR_COUNT, {
        variables: {
            id,
        },
    });

    const audience = data ? data.audience : null;

    return {
        audience,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
